import * as React from "react";
import { Col, Row } from "react-bootstrap";
import { GameI } from "../../../../../types";
import GamePreview from "../../GamePreview";

export const Ranking: React.FC<{ games: GameI[] }> = (props) => {
    const { games } = props;

    return (
        <>
            <Row>
                {games.map((game: GameI) => {
                    return (
                        <Col key={`game-card-${game.url}`} xl={3} lg={4} sm={6}>
                            <GamePreview game={game} />
                        </Col>
                    );
                })}
            </Row>
        </>
    );
};
